import React from "react";
import { useAuthContext } from "../../contexts/AuthContext";
import { useLanguage } from "../../contexts/LanguageContext";
import LoginForm from "./LoginForm";
import UserPanel from "./UserPanel";

const AuthSidebar: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuthContext();
  const { t } = useLanguage();

  return (
    <aside className="side-panel">
      <h3 className="panel-title">{t("common", "AuthSidebar.playerPortal")}</h3>

      {isLoading ? (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <i className="fas fa-spinner fa-spin"></i>
          <p>{t("common", "AuthSidebar.loading")}</p>
        </div>
      ) : isAuthenticated ? (
        <UserPanel />
      ) : (
        <LoginForm />
      )}

      <div className="social-login">
        <a href="#" className="social-btn">
          <i className="fab fa-google"></i>
        </a>
        <a href="#" className="social-btn">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="#" className="social-btn">
          <i className="fab fa-steam"></i>
        </a>
      </div>

      <div className="newsletter">
        <p>{t("common", "AuthSidebar.receiveNews")}</p>
        <form className="newsletter-form">
          <input
            type="email"
            placeholder={t("common", "AuthSidebar.emailPlaceholder")}
            required
          />
          <button type="submit" className="login-btn-form">
            {t("common", "buttons.subscribe")}
          </button>
        </form>
      </div>

      <div style={{ marginTop: "2rem", textAlign: "center" }}>
        <div className="version-info">
          {t("common", "AuthSidebar.version")} <span id="version">1.0.0</span> |{" "}
          {t("common", "AuthSidebar.lastVersion")}
          <span id="date">{new Date().toLocaleDateString("es-ES")}</span>
        </div>
      </div>
    </aside>
  );
};

export default AuthSidebar;
